'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Snackbar = require('material-ui/Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

var _PropertyHelper = require('../common/PropertyHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	action: _propTypes2.default.node,
	autoHideDuration: _propTypes2.default.number,
	bodyStyle: _propTypes2.default.object,
	className: _propTypes2.default.string,
	message: _propTypes2.default.node.isRequired,
	onActionClick: _propTypes2.default.func,
	onRequestClose: _propTypes2.default.func,
	open: _propTypes2.default.bool,
	style: _propTypes2.default.object
};

var allowedProperties = Object.keys(propTypes);

var WMSnackbar = function WMSnackbar(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_Snackbar2.default, (0, _PropertyHelper.filter)(props, allowedProperties))
	);
};

exports.default = WMSnackbar;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMSnackbar/index.js